/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_RecipientsInputs */



/**
* | output |
* | --- |
* | "Recipients" |
*
* @param {Compare_Event_Groups_Option_RecipientsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_recipients = /** @type {((inputs?: Compare_Event_Groups_Option_RecipientsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_RecipientsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bénéficiaires")
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfänger")
	if (locale === "it") return /** @type {LocalizedString} */ ("Destinatari")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получатели")
	if (locale === "es") return /** @type {LocalizedString} */ ("Destinatarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("收件人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("受信者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राप्तकर्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Destinatários")
	return /** @type {LocalizedString} */ ("Recipients")
});